import { render, staticRenderFns } from "./01.vue?vue&type=template&id=f2e35a1a"
import script from "./01.vue?vue&type=script&lang=ts"
export * from "./01.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports